import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Menu from '../Menu/Menu';
import hardAssetsAllianceBackground from '../../assets/images/svg/background-1.svg';
import Logo from '../Logo/Logo';
import { selectUser } from '../../store/selectors/userSelectors';
import Paragraph from '../Paragraph/Paragraph';
import SectionLoader from '../SectionLoader/SectionLoader';
import { selectIsLoadingByActionTypes } from '../../store/selectors/loadingSelectors';
import {
  CREATE_PERSON_NAME_LOADING,
  UPDATE_PERSON_NAME_LOADING,
  CREATE_PERSON_SSN_LOADING,
  UPDATE_PERSON_SSN_LOADING,
  CREATE_PERSON_ADDRESS_LOADING,
  UPDATE_PERSON_ADDRESS_LOADING,
  CREATE_PERSON_BIRTHDAY_LOADING,
  UPDATE_PERSON_BIRTHDAY_LOADING,
  CREATE_PERSON_COUNTRY_LOADING,
  UPDATE_PERSON_COUNTRY_LOADING,
  CREATE_PERSON_BACKUP_WITH_HOLDINGS_LOADING,
  UPDATE_PERSON_BACKUP_WITH_HOLDINGS_LOADING,
  CREATE_LEGAL_ENTITY_NAME_LOADING,
  UPDATE_LEGAL_ENTITY_NAME_LOADING,
  CREATE_LEGAL_ENTITY_EIN_LOADING,
  UPDATE_LEGAL_ENTITY_EIN_LOADING,
  CREATE_LEGAL_ENTITY_ADDRESS_LOADING,
  UPDATE_LEGAL_ENTITY_ADDRESS_LOADING,
} from '../../store/actions/person/personActionConstants';
import {
  CREATE_METAL_STREAM_AMOUNT_LOADING,
  UPDATE_METAL_STREAM_AMOUNT_LOADING,
  CREATE_METAL_STREAM_ALLOCATION_LOADING,
  UPDATE_METAL_STREAM_ALLOCATION_LOADING,
  CREATE_METAL_STREAM_PRODUCTS_LOADING,
  GET_METAL_STREAM_PRODUCTS_LOADING,
  GET_METAL_STREAM_GOLD_PRODUCTS_LOADING,
  GET_METAL_STREAM_SILVER_PRODUCTS_LOADING,
} from '../../store/actions/metalStream/metalStreamActionConstants';
import TextButton from '../TextButton/TextButton';
import {
  APPLICATION_TYPE_SETUP_LOADING,
  CREATE_ACCOUNT_TYPE_LOADING,
  CREATE_APPLICATION_STEP_LOADING,
  PATCH_ACCOUNT_TYPE_LOADING,
  GET_APPLICATION_LOADING,
} from '../../store/actions/application/applicationActionConstants';
import { CONNECT_ACH_BANK_ACCOUNTS_LOADING } from '../../store/actions/bankAccount/bankAccountActionConstants';
import {
  APPLICATION_FUNDING_AMOUNT_LOADING,
  APPLICATION_FUNDING_LOADING,
  BANK_APPLICATION_FUNDING_LOADING,
  METAL_STREAM_FUNDING_LOADING,
  UPDATE_APPLICATION_FUNDING_LOADING,
  UPDATE_BANK_APPLICATION_FUNDING_LOADING,
} from '../../store/actions/funding/fundingActionConstants';
import {
  CREATE_IRA_APPLICATION_ACCOUNT_NUMBER_LOADING,
  UPDATE_IRA_APPLICATION_ACCOUNT_NUMBER_LOADING,
  CREATE_IRA_APPLICATION_FUNDING_AMOUNT_LOADING,
  UPDATE_IRA_APPLICATION_FUNDING_AMOUNT_LOADING,
  CREATE_IRA_APPLICATION_TRANSFER_TYPE_LOADING,
  UPDATE_IRA_APPLICATION_TRANSFER_TYPE_LOADING,
  CREATE_IRA_APPLICATION_FUNDING_TYPE_LOADING,
  UPDATE_IRA_APPLICATION_FUNDING_TYPE_LOADING,
  CREATE_IRA_APPLICATION_ACCOUNT_TYPE_LOADING,
  DELETE_IRA_APPLICATION_FUNDING_LOADING,
} from '../../store/actions/iraFunding/iraFundingActionConstants';
import {
  CREATE_CUSTODIAN_LOADING,
  GET_CUSTODIANS_LOADING,
  UPDATE_CUSTODIAN_LOADING,
} from '../../store/actions/custodians/custodiansActionConstants';
import {
  GET_FUNDING_SOURCE_LOADING,
  APPLICATION_FUNDING_SOURCE_LOADING,
  UPDATE_APPLICATION_FUNDING_SOURCE_LOADING,
  GET_FUNDING_ACCOUNT_PURPOSE_LOADING,
  GET_FUNDING_SOURCE_ACCOUNT_DETAILS_LOADING,
} from '../../store/actions/fundingSource/FundingSourceConstants';
import Back from '../Buttons/Back';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import config from '../../config';
import themeColors from '../../assets/styles/themeColors';
import { selectSettings } from '../../store/selectors/settingsSelectors';
import AnchorLogo from '../AnchorLogo/AnchorLogo';
import { GET_BASIC_ACCOUNT_LOADING } from '../../store/actions/user/userActionConstants';
import MissingInfoBanner from '../MissingInfoBanner/MissingInfoBanner';
import { useGetIsImpersonating } from '../../util/hooks/useGetIsImpersonating';
import AssistedRegistrationBanner from '../AssistedRegistrationBanner/AssistedRegistrationBanner';
import Footer from '../Footer/Footer';
import TermsAndPrivacy from '../TermsAndPrivacy/TermsAndPrivacy';
import {
  GET_EMPLOYMENT_STATUS_LIST_LOADING,
  GET_OCCUPATION_CATEGORIES_LOADING,
  GET_OCCUPATION_CATEGORY_INFO_LOADING,
  GET_EMPLOYMENT_INFO_LOADING,
  CREATE_EMPLOYMENT_INFO_LOADING,
  UPDATE_EMPLOYMENT_INFO_LOADING,
  GET_INCOME_SOURCE_LIST_LOADING,
} from '../../store/actions/employmentStatus/employmentStatusActionConstants';
import {
  GET_IDENTIFICATION_TYPES_LOADING,
  IDENTIFICATION_SOURCE__DETAILS_LOADING,
  POST_IDENTIFICATION_INFO_LOADING,
  UPDATE_IDENTIFICATION_INFO_LOADING,
} from '../../store/actions/identificationVerification/identificationVerificationConstants';
import {
  CLIENT_COUNTRIES_LOADING,
  CLIENT_STATES_LOADING,
} from '../../store/actions/common/commonConstants';
import CloseWhiteIcon from '../Icons/CloseWhiteIcon';
import ExitConfirmationModal from '../Modals/ExitConfirmationModal/ExitConfirmationModal';
import { useSaveExitCrmEvent } from '../../util/helpers/crmEventsHelper';

const isContoso = () => {
  const { brokerTheme } = config;
  if (brokerTheme === 'Contoso') {
    return true;
  }
  return false;
};

const getHeaderBackground = () => {
  const { brokerTheme } = config;

  switch (brokerTheme) {
    case 'HardAssetsAlliance':
      return hardAssetsAllianceBackground;

    case 'GoldSilver':
      return;
    case 'LegacyPM':
      return;
    case 'Contoso':
      return;

    default:
      return hardAssetsAllianceBackground;
  }
};

const OnboardingContainerWrap = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const OnBoardingContainerStyles = styled.div`
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 900px) {
    padding: 0;
    flex-grow: 1;
  }
`;

const OnBoardingContainerBanner = styled.div`
  padding: 1.5rem;
  min-height: 17.5rem;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  ${({ showBackground, isGS }) =>
    showBackground && isGS
      ? `background: url(${getHeaderBackground()}), ${
          themeColors.colorSidebarBegin
        };`
      : `background-image: url(${getHeaderBackground()});`}
  background-size: ${({ isGS }) => (isGS ? 'contain' : 'cover')};
  ${({ isGS }) =>
    isGS && `background-repeat: no-repeat; background-position: right bottom`};
  padding: 1.5rem;

  @media only screen and (max-width: 900px) {
    position: relative;
    min-height: 6.25rem;
    display: flex;
    align-items: center;
    z-index: 0;
    ${({ isGS }) =>
      isGS
        ? `background: ${themeColors.colorSidebarBegin};`
        : `background-image: url(${getHeaderBackground()});
      `};
  }
`;

const OnBoardingContainerBannerInnerWrap = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media only screen and (max-width: 900px) {
    display: grid;
    grid-template-columns: 1fr;

    > :nth-child(1) {
      display: flex;
      justify-content: center;
      grid-row: 1 / 2;
      grid-column: 1 / 3;
      margin-bottom: 1rem;
    }

    > :nth-child(2) {
      display: flex;
      align-items: center;
      gap: 1rem;
      justify-content: space-between;
    }
  }
`;

const NavigationCloseIcon = styled(CloseWhiteIcon)`
  cursor: pointer;
  z-index: 1;
  width: 2.5rem;
  height: 2.5rem;

  /* Media queries */
  @media only screen and (max-width: 500px) {
    width: 2rem;
    height: 2rem;
  }

  @media only screen and (max-width: 420px) {
    width: 1.8rem;
    height: 1.8rem;
  }
`;

const OnBoardingContainerBodyWrap = styled.div`
  margin: 0 auto;
  max-width: 65.75rem;
  width: 100%;
  margin-top: 7.5rem;
  display: grid;
  grid-template-columns 1fr;
  grid-gap: 0.05rem;
  padding: 0 1.5rem;
  margin-top: -7.5rem;

  @media only screen and (max-width: 900px) {
    max-width: 100%;
    padding: 1.5rem 1.25rem;
    flex-grow: 1;
    flex-direction: column;
    display: flex;
    margin-top: 0;
  }
`;

const OnBoardingContainerBody = styled.div`
  min-height: 33.5rem;
  padding: 3.75rem;
  display: grid;
  grid-template-columns: 0.5fr 1fr;
  grid-gap: 4.75rem;
  background-color: ${themeColors.colorWhite};
  border: 1px solid ${themeColors.colorBorderSemiDark};
  border-radius: 4px;
  box-shadow: 0px 6px 18px rgba(0, 0, 0, 0.04);

  @media only screen and (max-width: 900px) {
    padding: 0;
    box-shadow: none;
    border: none;
    grid-template-columns: 1fr;
    grid-gap: 0;
    flex-grow: 1;
  }
`;

const OnBoardingChildrenContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 900px) {
    flex-grow: 1;
  }
`;

const BackContainer = styled.div`
  visibility: ${(props) => (props?.previousPath ? 'visible' : 'hidden')};

  @media only screen and (max-width: 900px) {
    display: none;
  }
`;

const BackMobileContainer = styled.div`
  display: none;
  visibility: ${(props) => (props?.previousPath ? 'visible' : 'hidden')};

  @media only screen and (max-width: 900px) {
    display: block;
  }
`;

const OnBoardingContainerBannerInnerEmailWrap = styled.div`
  @media only screen and (max-width: 500px) {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`;

const Onboarding = styled.div``;

const OnBoardingContainer = ({
  children,
  activeMenu,
  activeItem,
  previousPath,
  hasMissingInfo,
  formId,
  setEventType,
  eventType,
  setSaveAndCloseModalOpen,
  gtmStepTracker,
}) => {
  const user = useSelector(selectUser);
  const { t } = useTranslation();
  const { isSalesAssisted } = useGetIsImpersonating();
  const isLoading = useSelector(
    selectIsLoadingByActionTypes([
      CREATE_PERSON_NAME_LOADING,
      UPDATE_PERSON_NAME_LOADING,
      CREATE_PERSON_SSN_LOADING,
      UPDATE_PERSON_SSN_LOADING,
      CREATE_PERSON_ADDRESS_LOADING,
      UPDATE_PERSON_ADDRESS_LOADING,
      CREATE_PERSON_BIRTHDAY_LOADING,
      UPDATE_PERSON_BIRTHDAY_LOADING,
      CREATE_PERSON_COUNTRY_LOADING,
      UPDATE_PERSON_COUNTRY_LOADING,
      CREATE_PERSON_BACKUP_WITH_HOLDINGS_LOADING,
      UPDATE_PERSON_BACKUP_WITH_HOLDINGS_LOADING,
      CREATE_METAL_STREAM_AMOUNT_LOADING,
      UPDATE_METAL_STREAM_AMOUNT_LOADING,
      CREATE_METAL_STREAM_ALLOCATION_LOADING,
      UPDATE_METAL_STREAM_ALLOCATION_LOADING,
      GET_METAL_STREAM_PRODUCTS_LOADING,
      GET_METAL_STREAM_GOLD_PRODUCTS_LOADING,
      GET_METAL_STREAM_SILVER_PRODUCTS_LOADING,
      CREATE_METAL_STREAM_PRODUCTS_LOADING,
      CREATE_LEGAL_ENTITY_NAME_LOADING,
      UPDATE_LEGAL_ENTITY_NAME_LOADING,
      CREATE_APPLICATION_STEP_LOADING,
      CREATE_LEGAL_ENTITY_NAME_LOADING,
      CREATE_LEGAL_ENTITY_EIN_LOADING,
      UPDATE_LEGAL_ENTITY_EIN_LOADING,
      CREATE_LEGAL_ENTITY_ADDRESS_LOADING,
      UPDATE_LEGAL_ENTITY_ADDRESS_LOADING,
      APPLICATION_TYPE_SETUP_LOADING,
      CREATE_ACCOUNT_TYPE_LOADING,
      PATCH_ACCOUNT_TYPE_LOADING,
      CONNECT_ACH_BANK_ACCOUNTS_LOADING,
      APPLICATION_FUNDING_LOADING,
      UPDATE_APPLICATION_FUNDING_LOADING,
      BANK_APPLICATION_FUNDING_LOADING,
      UPDATE_BANK_APPLICATION_FUNDING_LOADING,
      METAL_STREAM_FUNDING_LOADING,
      APPLICATION_FUNDING_AMOUNT_LOADING,
      UPDATE_APPLICATION_FUNDING_LOADING,
      CREATE_IRA_APPLICATION_ACCOUNT_NUMBER_LOADING,
      UPDATE_IRA_APPLICATION_ACCOUNT_NUMBER_LOADING,
      CREATE_IRA_APPLICATION_FUNDING_AMOUNT_LOADING,
      UPDATE_IRA_APPLICATION_FUNDING_AMOUNT_LOADING,
      CREATE_IRA_APPLICATION_TRANSFER_TYPE_LOADING,
      UPDATE_IRA_APPLICATION_TRANSFER_TYPE_LOADING,
      CREATE_IRA_APPLICATION_FUNDING_TYPE_LOADING,
      UPDATE_IRA_APPLICATION_FUNDING_TYPE_LOADING,
      CREATE_IRA_APPLICATION_ACCOUNT_TYPE_LOADING,
      GET_CUSTODIANS_LOADING,
      UPDATE_CUSTODIAN_LOADING,
      CREATE_CUSTODIAN_LOADING,
      DELETE_IRA_APPLICATION_FUNDING_LOADING,
      GET_BASIC_ACCOUNT_LOADING,
      GET_FUNDING_SOURCE_LOADING,
      UPDATE_APPLICATION_FUNDING_SOURCE_LOADING,
      APPLICATION_FUNDING_SOURCE_LOADING,
      GET_FUNDING_SOURCE_ACCOUNT_DETAILS_LOADING,
      GET_FUNDING_ACCOUNT_PURPOSE_LOADING,
      GET_EMPLOYMENT_STATUS_LIST_LOADING,
      GET_OCCUPATION_CATEGORIES_LOADING,
      GET_OCCUPATION_CATEGORY_INFO_LOADING,
      GET_EMPLOYMENT_INFO_LOADING,
      CREATE_EMPLOYMENT_INFO_LOADING,
      UPDATE_EMPLOYMENT_INFO_LOADING,
      GET_INCOME_SOURCE_LIST_LOADING,
      GET_IDENTIFICATION_TYPES_LOADING,
      CLIENT_STATES_LOADING,
      CLIENT_COUNTRIES_LOADING,
      IDENTIFICATION_SOURCE__DETAILS_LOADING,
      POST_IDENTIFICATION_INFO_LOADING,
      UPDATE_IDENTIFICATION_INFO_LOADING,
      GET_APPLICATION_LOADING,
    ]),
  );
  const { width } = useWindowDimensions();
  const settings = useSelector(selectSettings);
  const [
    isExitConfirmationModalOpen,
    setIsExitConfirmationModalOpen,
  ] = useState(false);
  const logoAnchor = () => {
    if (settings.WebsiteUrl) {
      if (String(settings.WebsiteUrl).includes('https://')) {
        return settings.WebsiteUrl;
      }

      return `https://${settings.WebsiteUrl}`;
    }
  };
  const handleCrmEvent = useSaveExitCrmEvent();

  // const logout = () => {
  //   dispatch(logoutUser());
  // };
  return (
    <OnboardingContainerWrap>
      <Onboarding>
        <SectionLoader isLoading={isLoading}>
          <OnBoardingContainerStyles>
            <OnBoardingContainerBanner
              showBackground={!isContoso()}
              isGS={config.brokerTheme === 'GoldSilver'}
            >
              <OnBoardingContainerBannerInnerWrap>
                {!isEmpty(user) && (
                  <div
                    style={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    {width <= 420 ? (
                      <>
                        <BackMobileContainer previousPath={previousPath}>
                          <Back
                            onClick={
                              gtmStepTracker
                                ? () => gtmStepTracker()
                                : undefined
                            }
                            showTitle={false}
                            path={previousPath}
                            color={themeColors.colorWhite}
                          />
                        </BackMobileContainer>

                        <AnchorLogo
                          type="website"
                          value={logoAnchor()}
                          text={<Logo />}
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            position: 'absolute',
                            left: '50%',
                            transform: 'translateX(-50%)',
                          }}
                        />

                        <OnBoardingContainerBannerInnerEmailWrap>
                          {!isSalesAssisted && (
                            <NavigationCloseIcon
                              w="24px"
                              onClick={() =>
                                setIsExitConfirmationModalOpen(true)
                              }
                              h="24px"
                              color={themeColors.colorWhite}
                            />
                          )}
                        </OnBoardingContainerBannerInnerEmailWrap>
                      </>
                    ) : (
                      <>
                        <AnchorLogo
                          type="website"
                          value={logoAnchor()}
                          text={<Logo />}
                        />
                        <OnBoardingContainerBannerInnerEmailWrap>
                          {!isSalesAssisted && (
                            <div
                              style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                              }}
                            >
                              <TextButton
                                emailVariant
                                onClick={() =>
                                  setIsExitConfirmationModalOpen(true)
                                }
                              >
                                <Paragraph
                                  color={themeColors.colorWhite}
                                  emailVariant
                                  verticalAlign
                                >
                                  {t('loginFluent.saveExit')}
                                </Paragraph>
                              </TextButton>
                              <NavigationCloseIcon
                                onClick={() =>
                                  setIsExitConfirmationModalOpen(true)
                                }
                              />
                            </div>
                          )}
                        </OnBoardingContainerBannerInnerEmailWrap>
                      </>
                    )}
                  </div>
                )}
              </OnBoardingContainerBannerInnerWrap>
            </OnBoardingContainerBanner>
            <OnBoardingContainerBodyWrap>
              {hasMissingInfo && <MissingInfoBanner />}
              <BackContainer previousPath={previousPath}>
                <Back
                  onClick={gtmStepTracker ? () => gtmStepTracker() : undefined}
                  showTitle
                  path={previousPath}
                  color={themeColors.colorWhite}
                />
              </BackContainer>
              <OnBoardingContainerBody>
                {!isEmpty(activeMenu) && (
                  <Menu activeMenu={activeMenu} activeItem={activeItem} />
                )}
                <OnBoardingChildrenContainer>
                  {children && children}
                </OnBoardingChildrenContainer>
              </OnBoardingContainerBody>
            </OnBoardingContainerBodyWrap>
          </OnBoardingContainerStyles>
        </SectionLoader>
      </Onboarding>
      <ExitConfirmationModal
        isOpen={isExitConfirmationModalOpen}
        onClose={setIsExitConfirmationModalOpen}
        saveAndExit={() => {
          window.location.replace(settings.PortalUrl);
        }}
        handleCrmEvent={handleCrmEvent}
        registrationUrl={`${window.location.origin}${window.location.pathname}`}
      />
      <AssistedRegistrationBanner
        formId={formId}
        setEventType={setEventType}
        eventType={eventType}
        setSaveAndCloseModalOpen={setSaveAndCloseModalOpen}
      />
      <TermsAndPrivacy marginTop={30} />
      <Footer />
    </OnboardingContainerWrap>
  );
};

OnBoardingContainer.propTypes = {
  children: PropTypes.node,
  activeMenu: PropTypes.arrayOf(PropTypes.shape({})),
  activeItem: PropTypes.shape({
    previousPath: PropTypes.string,
    nextPath: PropTypes.string,
  }),
  previousPath: PropTypes.string,
  hasMissingInfo: PropTypes.bool,
  formId: PropTypes.string,
  setEventType: PropTypes.func,
  eventType: PropTypes.string,
  setSaveAndCloseModalOpen: PropTypes.func,
  gtmStepTracker: PropTypes.func,
};

export default OnBoardingContainer;
